import createSolidComponent from '../createSolidComponent';
export default createSolidComponent('outline', 'space-off', 'SpaceOff', [["path",{"d":"M4 10v3a1 1 0 0 0 1 1h9m4 0h1a1 1 0 0 0 1 -1v-3"}],["path",{"d":"M3 3l18 18"}]]);